import { useCallback, useRef, useState } from "react";
import Webcam from "react-webcam";
import { useTranslation } from 'react-i18next';
import * as global from './global';

const videoConstraints = {
    facingMode: {ideal : "environment"},
    //width: { ideal: 720 },
    //height: { ideal: 1280 },
    frameRate: { ideal: 30 }
};

const WebcamCapture = ({onCapture}) => {
    const { t } = useTranslation();
    const webcamRef = useRef(null);
    const [imgSrc, setImgSrc] = useState(null);
    const [captureSound] = useState(new Audio('/assets/sound/snapshot.wav'));

    const capture = useCallback(() => {
        if (!webcamRef.current) return;
        const imageSrc = webcamRef.current.getScreenshot();
        setImgSrc(imageSrc);
        onCapture(imageSrc);
        captureSound.play();
    }, [webcamRef, setImgSrc]);

    const reset = useCallback(() => {
        setImgSrc(null);
        onCapture(null);
    }, [setImgSrc]);

    return (
        <>
            {!imgSrc &&
            <Webcam
                audio={false}
                ref={webcamRef}
                style={{
                    width: "100%",
                    //height: "auto",
                    borderRadius: "10px",
                }}
                screenshotFormat="image/jpeg"
                videoConstraints={videoConstraints}
                screenshotQuality={global.PHOTO_QUALITY}
                minScreenshotWidth={480}
                minScreenshotHeight={640}
                maxScreenshotWidth={global.PHOTO_MAXRES}
                maxScreenshotHeight={global.PHOTO_MAXRES}
            />}
            {imgSrc && 
            <div className="" > 
                <img src={imgSrc} alt="img" className="img-adjust" style={{ borderRadius: "10px", paddingBottom:"6px" }}/>
            </div>}
            <div className="row">
                <div className="btn-del-val col-6">
                    <button className="btn-block btn btn-primary" onClick={reset}>{t('DELIVERY_RESET_CAMERA')}</button>
                </div>
                <div className="btn-del-val col-6">
                    <button className="btn-block btn btn-default" onClick={capture}>{t('DELIVERY_BUTTON_CAMERA')}</button>
                </div>
            </div>
        </>
    );
};

export default WebcamCapture;